<template>
  <div class="loader-container" :class="{ 'fade-out': !isLoading }">
    <div class="loader">
      <picture>
        <source srcset="@/assets/images/logo.webp" type="image/webp" />
        <img
          src="@/assets/images/logo.png"
          alt="Good Bareto Logo"
          class="loader-logo"
          width="200"
          height="95"
          decoding="async"
          loading="eager"
          fetchpriority="high"
        />
      </picture>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { isInitialLoadComplete, forceCompleteInitialLoad } from '@/composables/useInitialLoad'

const isLoading = ref(true)
let safetyTimeout = null

watch(
  isInitialLoadComplete,
  (done) => {
    if (done) {
      isLoading.value = false
    }
  },
  { immediate: true }
)

onMounted(() => {
  safetyTimeout = window.setTimeout(() => {
    forceCompleteInitialLoad()
  }, 8000)
})

onBeforeUnmount(() => {
  if (safetyTimeout) {
    window.clearTimeout(safetyTimeout)
    safetyTimeout = null
  }
})
</script>

<script>
export default {
  name: 'LoaderAnimation'
}
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100svh;
  background: var(--white-color);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.5s, visibility 0.5s;
}

.fade-out {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.loader-logo {
  width: 200px;
  height: auto;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}
</style>
